<template>
  <Layout>
    <div class="section content has-text-white">
      <h1 class="is-size-5 has-text-primary">{{ $t('Imprint') }}</h1>
      <span class="is-size-7">
        <p>
          Гамесманиацлоунге је заштитни знак компаније 778мобиле ГмбХ.
          Број у пословном регистру: Дüсселдорф: ХРБ 79227
          ПДВ број: ДЕ303966009
          Адреса:  778mobile GmbH, Am Wehrhahn 50, 40211 Düsseldorf, Nemačka
          Емаил: <a class="has-text-primary" href="mailto:gamegame.rs@silverlines.info">gamegame.rs@silverlines.info</a><br>
          Тел: <a class="has-text-primary" href="tel:0113216815">0113216815</a><br>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangGG/RS/Imprint.vue